import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { palatineConfig } from "./data";

export default function PalatinePage() {
  return <CityPageTemplate config={palatineConfig} />;
}